import { documentApi } from "api/document.api";
import { BDocumentList, BSpin } from "components/base";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { chatStore } from "store/chatStore";
import type { Document } from "types/document";
import "./SidebarDocuments.scss";
import { userStore } from "store/userStore";

const SidebarDocuments = observer(function SidebarDocuments() {
  const { selectedProjectId } = chatStore;
  const [documents, setDocuments] = useState<Document[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!selectedProjectId) {
      setDocuments([]);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const res = await documentApi.findAll({
          projectId: selectedProjectId,
          page: 1,
          limit: 100,
          staffId: userStore.info.id,
        });
        if (cancelled) {
          return;
        }
        setDocuments(res.data?.documents ?? []);
      } catch {
        if (!cancelled) {
          setDocuments([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedProjectId]);

  if (!selectedProjectId) {
    return null;
  }

  if (loading) {
    return (
      <div className="sidebar-documents sidebar-documents--loading">
        <BSpin size="small" />
      </div>
    );
  }

  return (
    <div className="sidebar-documents">
      <BDocumentList items={documents} />
    </div>
  );
});

export default SidebarDocuments;
